import { render, staticRenderFns } from "./ExpressWords.vue?vue&type=template&id=0928b4d8&scoped=true&"
import script from "./ExpressWords.vue?vue&type=script&lang=js&"
export * from "./ExpressWords.vue?vue&type=script&lang=js&"
import style0 from "./ExpressWords.vue?vue&type=style&index=0&id=0928b4d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0928b4d8",
  null
  
)

export default component.exports